module.exports = __webpack_public_path__ + "static/media/fb4.bc7ec818.png";